module.exports = __webpack_public_path__ + "static/media/6.ae73d5a1.png";